export default {
  data() {
    return {}
  },
  watch: {
    selectedColumns: {
      handler(newValue) {
        if (this.$auth.user.name) {
          const key = `${this.selectedColumnsStore}-${this.$auth.user.name}`
          localStorage.setItem(key, JSON.stringify(newValue));        
        }
      },
      deep: true
    }
  },
  created() {
    if (this.$auth.user.name) {
      const key = `${this.selectedColumnsStore}-${this.$auth.user.name}`
      const storedColumns = localStorage.getItem(key);
      if (storedColumns) {
        this.selectedColumns = JSON.parse(storedColumns);
      }
    }
  },
}  